import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { SvcGlobalDataPrefetching } from '../../data-prefetching/svc-global-data-prefetching';
import { CMMS_FLAG_PARAMETERS, CmmsFlagModule } from './cmms-flag.constants';
import { ParameterService } from './parameter.service';

@Injectable({
  providedIn: 'root',
})
export class CmmsFlagService {
  private readonly _globalDataPrefetching = inject(SvcGlobalDataPrefetching);
  private readonly _parameterService = inject(ParameterService);

  public isEnabled$(module: CmmsFlagModule): Observable<boolean> {
    const data = this._globalDataPrefetching.data;
    const item = module === 'defectTag' ? data?.defectTagShowIntegrationCmms : data?.unsafeConditionShowIntegrationCmms;

    if (item?.value$) {
      return item.value$;
    }

    if (item?.isLoading$) {
      return item.isLoading$.pipe(
        filter((isLoading) => !isLoading),
        map(() => item.value)
      );
    }

    if (typeof item?.value === 'boolean') {
      return of(item.value);
    }

    return this.fetch$(module);
  }

  public fetch$(module: CmmsFlagModule): Observable<boolean> {
    return this._parameterService.getSiteParam(CMMS_FLAG_PARAMETERS[module]).pipe(
      map((value) => value?.toUpperCase() === 'TRUE'),
      catchError(() => of(false))
    );
  }
}
